export const RandomSubjects = [
    'Africa',
    'basketball',
    'canoes',
    'cheese',
    'circus',
    'coins',
    'crime',
    'dentistry',
    'giraffes',
    'gold',
    'hippopotamus',
    'lighters',
    'mining',
    'mining',
    'motorcycles',
    'mules',
    'murderers',
    'pharmacy',
    'pigs',
    'pigs',
    'puppets',
    'skull',
    'spas',
    'spinning',
    'surfing',
    'tanning',
    'tattoos',
    'tigers',
    'toads',
    'vanilla',
    'whales',
    'windmills',
]